define('SageDotCom/Components/Content/IntacctResourcesCentre/IntacctResourcesResults',["jquery",
    "underscore",
    "eventManager",
    "SageDotCom/Components/Pagination",
    "SageDotCom/DataLayer/Events/CustomerSuccess/filterEvent",
    "text!SageDotCom/Components/Templates/IntacctResourceResultsFilters.html",
    "text!SageDotCom/Components/Templates/IntacctResourceCard.html"],
    // ReSharper disable InconsistentNaming
    function ($, _, eventManager, pagination, filterEvent, _templateResultsFilters, _templateResourceCard) {
        function IntacctResourcesResults(scope, navigator, div, itemsPerPageDesktop, itemsPerPageMobile) {
            var $resultsFilterDiv = $(".filter-pill-container");
            var $storiesCountLabelOrig = $(".filter-props .stories-label");
            var $storiesCountLabelText = $storiesCountLabelOrig.text();
            var resizeTimer = null;
            var globalFilteredData = {};
            var marketsDisabled = false;
            var hideResultsView = true;
            var itemsPerPage = $(".intacct-resources-results-wrapper .intacct-resources").hasClass("is-mobile")
                ? itemsPerPageMobile
                : itemsPerPageDesktop;

            function init() {
                $(".intacct-results-view").css({ "visibility": "hidden" });
                $(".intacct-resources-results-wrapper").hide();

                eventManager.subscribe("intacct-resources-filter-changed", function (filteredData) {
                    if (filteredData.length === 0) {
                        //show no results text
                        return;
                    } else {
                        globalFilteredData = filteredData;
                        var intacctResourceResults = document.querySelector('.intacct-resources-results-wrapper');
                        var intacctResource = document.querySelector('[id^="intacctresourcescenter-"]');

                        if (checkFilterIsApplied(globalFilteredData)) {
                            hideResultsView = false; 

                            if (intacctResource) {
                                intacctResource.style.display = 'none'
                            }
                            
                            if (intacctResourceResults) {
                                intacctResourceResults.style.display = 'block';
                            }

                            $(".intacct-results-view").css({ "visibility": "hidden" });
                            addSpinner($(".intacct-resources-results-wrapper"));

                            var $storiesCountLabel =
                                $storiesCountLabelText.replace("0", filteredData.intacctResultsData.length);
                            $storiesCountLabelOrig.html($storiesCountLabel);

                            // generate an underscore template for results page filters
                            var resultsFilterTemplate = _.template(_templateResultsFilters);
                            var html = "";

                            html += resultsFilterTemplate(filteredData);
                            $resultsFilterDiv.html(html);

                            pagination.init(scope,
                                _templateResourceCard,
                                navigator,
                                div,
                                filteredData.intacctResultsData,
                                itemsPerPage);

                            removeSpinner($(".intacct-resources-results-wrapper"));
                            $(".intacct-results-view").css({ "visibility": "visible" });
                            eventManager.trigger("invoke-lazy-load");
                        } else {
                            removeSpinner($(".intacct-resources-results-wrapper"));
                            $(".intacct-results-view").css({ "visibility": "hidden" });

                            if (intacctResourceResults) {
                                intacctResourceResults.style.display = 'none';
                            }

                            if (intacctResource) {
                                intacctResource.style.display = 'block'
                            }
                        }
                    }
                });

                eventManager.subscribe("intacct-results-reset-btn-clicked", function () {
                    hideResultsView = true;
                    var intacctResource = document.querySelector('[id^="intacctresourcescenter-"]');
                    $(".intacct-results-view").css({ "visibility": "hidden" });
                    if (intacctResource) {
                        intacctResource.style.display = 'block';
                    }

                    eventManager.trigger("intacct-resources-filter-reset");
                });

                eventManager.subscribe("intacct-results-pill-clear-clicked", function (filterName, filterIndex) {
                    if (typeof globalFilteredData[filterName] !== "undefined" && globalFilteredData[filterName].length > 0) {
                        if (filterName !== "Markets" || !marketsDisabled) {
                            //var facetObj = globalFilteredData[filterName][filterIndex];
                            //new filterEvent(false, true, false, facetObj.name, filterName).trigger();
                            globalFilteredData[filterName].splice(filterIndex, 1);
                            addSpinner($(".customer-success-results-wrapper"));
                            $(".intacct-results-view").css({ "visibility": "hidden" });
                            eventManager.trigger("resources-filter-result-page-change", globalFilteredData);
                        }
                    }
                });
            };

            $(".intacct-results-view .filter-props").delegate(".reset-btn", "click", function() {
                //new filterEvent(true, true).trigger();

                eventManager.trigger("intacct-results-reset-btn-clicked");
            });

            $(".intacct-results-view .filter-pill-container").delegate(".filter-pill", "click", function () {
                var filterName = $(this).find("p").attr("name");
                var filterIndex = $(this).find("p").attr("index");

                eventManager.trigger("intacct-results-pill-clear-clicked", filterName, filterIndex);
            });
            
            //add 3 square spinner
            function addSpinner(context) {
                context.append("<div class='loader'></div>");
                var spinner = context.find(".loader");
                spinner.append("<div class='bounce bounce1'></div>");
                spinner.append("<div class='bounce bounce2'></div>");
                spinner.append("<div class='bounce bounce3'></div>");
            }

            function removeSpinner(context) {
                var spinner = context.find(".loader");
                spinner.remove();
            }

            function checkFilterIsApplied(data) {
                if (data["ContentType"].length < 1 && data["Industry"].length < 1 && data["Product"].length < 1 && hideResultsView) 
                    return false;
                 else 
                    return true;
            }

            $(window).on("resize orientationchange", function () {
                if (resizeTimer) {
                    clearTimeout(resizeTimer);
                }
                resizeTimer = setTimeout(function () {
                    if ($(".filter-pill-container").length > 0) {
                        if (document.body.clientWidth > 1080) {
                            var pillContainerEl = jQuery(".intacct-results-view > .filter-pill-container");
                            if (pillContainerEl.length > 0) 
                                $('[id^="intacctresourcescenterresults-"] .title-Container').append(pillContainerEl);
                            
                        } else {
                            var pillContainerEl = jQuery(".intacct-results-view .title-Container .filter-pill-container");
                            if (pillContainerEl.length > 0) 
                                $('[id^="intacctresourcescenterresults-"] .intacct-resources-results-heading').after(pillContainerEl);
                        }
                    }
                }, 200);
            });

            init();
        };

        return function initIntacctResourcesResult(args) {
            return args.IsExperienceEditorEditing ? null : new IntacctResourcesResults(args.scope, args.navigator, args.div, args.itemsPerPageDesktop, args.itemsPerPageMobile);
        };
    });
